import { render } from "./TrebleButtonComponent.vue?vue&type=template&id=a13aab2a&scoped=true"
import script from "./TrebleButtonComponent.vue?vue&type=script&lang=js"
export * from "./TrebleButtonComponent.vue?vue&type=script&lang=js"

import "./TrebleButtonComponent.vue?vue&type=style&index=0&id=a13aab2a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a13aab2a"]])

export default __exports__